import { render, staticRenderFns } from "./JielongIntroDemo.vue?vue&type=template&id=222481f4&scoped=true"
import script from "./JielongIntroDemo.vue?vue&type=script&lang=ts"
export * from "./JielongIntroDemo.vue?vue&type=script&lang=ts"
import style0 from "./JielongIntroDemo.vue?vue&type=style&index=0&id=222481f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222481f4",
  null
  
)

export default component.exports